import { TrainingTab } from '../company/TrainingTab.tsx';

// The driver Training tab is the shared tab pointed at the driver endpoints.
export function DriverTraining() {
  return <TrainingTab apiPrefix="/api/driver/me" />;
}
